<template>
    <span @mouseover="isHovering = true"
          @mouseout="isHovering = false"
          :style="{display: display}"
    >
      <svg xmlns="http://www.w3.org/2000/svg"
           :width="width"
           :height="height"
           :aria-labelledby="iconName"
           role="presentation"
           :style="{'vertical-align': verticalAlign }"
           :viewBox="viewBox">
          <g :fill="getIconColor">
            <component :is="componentName"/>
          </g>
      </svg>
    </span>
</template>

<script>
export default {
    props: {
        iconName: {
            type: String,
            default: ''
        },
        width: {
            type: [Number, String],
            default: 18
        },
        height: {
            type: [Number, String],
            default: 18
        },
        iconColor: {
            type: String,
            default: 'currentColor'
        },
        iconHoverColor: {
            type: String
        },
        display: {
            type: String,
            default: 'inline-block'
        },
        verticalAlign: {
            type: String,
            default: ''
        }
    },
    computed: {
        getIconColor() {
            if (!this.iconHoverColor) {
                return this.iconColor;
            }
            return this.isHovering ? this.iconHoverColor : this.iconColor;
        },
        componentName() {
            if (this.iconName) {
                // eslint-disable-next-line no-return-await,global-require,import/no-dynamic-require
                return async () => await require((`./icons/${this.iconName}.vue`));
            }
            return null;
        }
    },
    data() {
        return {
            viewBox: '0 0 18 18',
            isHovering: false
        };
    },
    beforeCreate() {
        this.$on('size', (newSize) => {
            this.viewBox = newSize;
        });
    }
};
</script>
